<div>
  <ngx-spinner *ngIf="!isPDF" bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#1d71b8" type="line-scale"></ngx-spinner>
  <app-calc-sheet [sheetComponent]="this" [isPDF]="isPDF" [expandedOldRowsTCO]="expandedOldRowsTCO" [columnsWidths] = "columnsWidths"  *ngIf="typeView==0"></app-calc-sheet>
  <app-equipment [sheetComponent]="this" [expandedOldRowsEquip]="expandedOldRowsEquip" [columnsWidths] = "columnsWidths" *ngIf="typeView==1"></app-equipment>
  <app-maintenance [sheetComponent]="this" [expandedOldRowsMaint]="expandedOldRowsMaint" [columnsWidths] = "columnsWidths" *ngIf="typeView==2"></app-maintenance>
</div>
